import {AbstractSerialBadgeType} from './abstract-serial-badge-type';

export class EnergyLevelEveningBadgeType extends AbstractSerialBadgeType {
  constructor() {
    super();
    this.name = 'energyLevelEvening';
    this.prettyName = 'Energiebewertung Abends';
    this.icon = 'battery-half';
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/models/badges/energy-level-evening-badge-type.ts